import { baseUrl, baseUrlWithoutApi } from '../../../baseurl';
import { create } from 'zustand';
import axios from 'axios';

export const useAuth = create((set, get) => ({
    

    authCode: "",
    isAuthenticateByToken: "",
    errorMsg: false,
    authData: "",
    // isFollow: [],
    loader: false,

    actions: {
        sendToken: async (phoneNumber,invitationCode) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseUrlWithoutApi}/Login/SendToken`, {
                "phoneNumber": phoneNumber,
                "invitationCode": invitationCode,
            })
                .then((res) => {
                    set((state) => ({ authCode: res.data }))
                    set((state) => ({ loader: false }))
                })
        },
        authenticateByToken: async (phoneNumber, token) => {
            await axios.post(`${baseUrlWithoutApi}/Login/AuthenticateByToken`, {
                "phoneNumber": phoneNumber,
                "token": token
            })
                .then((res) => {
                    if (res.data.token === null) {
                        set((state) => ({ errorMsg: true }))
                    } else {
                        console.log("ok token");
                        localStorage.setItem("veeuToken", res.data.token)
                        // function parseJwt(token) {
                        var base64Url = res.data.token.split('.')[1];
                        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                        }).join(''));
                        set((state) => ({ authData: JSON.parse(jsonPayload) }))
                        console.log(JSON.parse(jsonPayload).unique_name)
                        localStorage.setItem("veeuAuthData", JSON.parse(jsonPayload).unique_name)
                        
                        // window.location.replace('/LoginThirdStep');
                        window.location.replace('/');
                        
                        //    JSON.parse(jsonPayload);
                        // }
                    }
                })
        },

        // getAdsUserFollow: async (userId, adsMasterUserId) => {
        //     set((state) => ({ loader: true }))
        //     await axios.post(`${baseUrlWithoutApi}/User/GetAdsUserFollow`, {
        //         "userId": userId,
        //         "adsMasterUserId": adsMasterUserId
        //     })
        //         .then((res) => {
        //             if (res.data) {
        //                 set((state) => ({ isFollow: res.data }))
        //                 set((state) => ({ loader: false }))
        //             }
        //         })
        // },


    }

}))